import React, { useEffect, useState } from 'react';

import debounce from 'lodash.debounce';

import {
    useRfidCards,
    useRfidCardsFilter,
} from '../../../state/app/registers/index.hooks';
import {
    fetchRfidCards,
    setRfidCardsFilter,
} from '../../../state/app/registers/rfidCards';
import { showRFIDCardDialog } from '../../../state/ui/dialog';

import RFIDCard from '../../../models/registers/RFIDCard';

import Translator from '../../../helpers/TranslationHelper';

import { DEBOUNCE_MID } from '../../../constants/DebounceValues';

import { useAppDispatch } from '../../../hooks';

import Pagination from '../../common/Pagination';
import PhraseFilter from '../../common/PhraseFilter';
import RFIDCardsTable from './RFIDCardsTable';
import TableWrapper from '../_shared/TableWrapper';
import ImportCards from './components/ImportCards';
import GroupFilter from '@/app/components/registers/_shared/GroupFilter';

const RFIDCards = () => {
    const [currentPage, setCurrentPage] = useState<number>(1);

    const filter = useRfidCardsFilter();
    const rfidCards = useRfidCards();

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchRfidCards(filter));
    }, [filter]);

    const handleGroupChange = (option: { id: string }) => {
        const updatedFilter = {
            ...filter,
            group: option && option.id,
            start: 0,
        };
        setCurrentPage(1);
        dispatch(setRfidCardsFilter({ rfidCardsFilter: updatedFilter }));
    };

    const handlePageChange = (selectedPageNumber: number) => {
        const targetPageNumber = selectedPageNumber || currentPage;
        const limit = filter.limit || 1;
        const updatedFilter = {
            ...filter,
            start: (targetPageNumber - 1) * limit,
        };
        setCurrentPage(targetPageNumber);
        dispatch(setRfidCardsFilter({ rfidCardsFilter: updatedFilter }));

        const element = document.querySelector(
            '#registersPageContent .content'
        );
        element?.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const handleFilterRFIDCards = debounce((name: string) => {
        const updatedFilter = {
            ...filter,
            name,
            start: 0,
        };
        setCurrentPage(1);
        dispatch(setRfidCardsFilter({ rfidCardsFilter: updatedFilter }));
    }, DEBOUNCE_MID);

    const handleAddRFIDCardButtonClick = () => {
        dispatch(showRFIDCardDialog({ rfidCard: new RFIDCard() }));
    };

    return (
        <section className="rfid-cards">
            <header className="header">
                <div className="header-filter">
                    <PhraseFilter
                        placeholder={Translator.translate('Find cards') + ' '}
                        onFilter={handleFilterRFIDCards}
                        filter={filter.name || ''}
                        autoFocus={true}
                        className="header-filter--input"
                    />
                    <GroupFilter
                        name="card-group"
                        selectedOptionId={filter.group}
                        placeholder={Translator.translate('Find by group')}
                        onOptionSelect={handleGroupChange}
                    />
                </div>
                <div>
                    <ImportCards />
                    <button
                        className="mtl-button primary margin_left"
                        onClick={handleAddRFIDCardButtonClick}
                    >
                        {Translator.translate('New RFID card')}
                    </button>
                </div>
            </header>
            <TableWrapper>
                <RFIDCardsTable
                    rfidCards={rfidCards ? rfidCards.items : undefined}
                />
            </TableWrapper>
            {rfidCards && (
                <Pagination
                    totalResults={rfidCards.total}
                    currentPage={currentPage}
                    onPageSelect={handlePageChange}
                    resultsPerPage={filter.limit}
                />
            )}
        </section>
    );
};

export default RFIDCards;
